// @flow

import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';
import rocketUrl from '../images/login-rocket.svg';
import starsUrl from '../images/login-stars.png';
import teamMobileUrl from '../images/login-team-mobile.svg';
import teamUrl from '../images/login-team.svg';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'none',
    [theme.breakpoints.gt.tablet.portrait]: {
      height: '100%',
      overflow: 'auto',
      position: 'fixed',
      right: 0,
      bottom: 0,
      float: 'left',
      width: '50%',
      display: 'flex'
    }
  },
  image: {
    width: '100%',
    height: 'auto',
    minWidth: '18.75rem',
    minHeight: '18.75rem'
  },
  team: {
    height: '100%',
    overflow: 'hidden'
  },
  teamImage: {
    [theme.breakpoints.gt.tablet.portrait]: {
      position: 'relative',
      backgroundImage: `url(${teamMobileUrl})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      height: '100%',
      width: '100%'
    },
    [theme.breakpoints.gt.tablet.landscape]: {
      backgroundImage: `url(${teamUrl})`
    }
  },
  rocket: {
    backgroundImage: `url(${starsUrl})`,
    backgroundPosition: 'bottom right',
    backgroundColor: theme.colors.porpoise,
    height: '100%',
    overflow: 'hidden',
    backgroundSize: 'cover'
  },
  rocketImage: {
    [theme.breakpoints.gt.tablet.portrait]: {
      backgroundImage: `url(${rocketUrl})`,
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      backgroundPosition: 'top',
      backgroundSize: 'cover',
      height: '100%',
      width: '100%'
    }
  }
}));

type Props = {
  hasRocket: boolean,
  hasTeamImage: boolean
};

export const LoginSplitScreenRight = ({ hasRocket, hasTeamImage }: Props) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div
      className={classNames(classes.root, {
        [classes.rocket]: hasRocket,
        [classes.team]: hasTeamImage
      })}
    >
      {hasRocket ? (
        <div
          className={classes.rocketImage}
          role="img"
          aria-label={intl.formatMessage({
            defaultMessage: 'Access Granted',
            id: 'login.rocketImage'
          })}
        />
      ) : hasTeamImage ? (
        <div
          className={classes.teamImage}
          role="img"
          aria-label={intl.formatMessage({
            defaultMessage: 'Master your business operations.',
            id: 'login.teamImage'
          })}
        />
      ) : null}
    </div>
  );
};
LoginSplitScreenRight.displayName = 'LoginSplitScreenRight';

export default LoginSplitScreenRight;
